<template>
  <div id="app">
    <v-header v-show="this.$route.meta.isShowComm"></v-header>
    <!--<img src="./assets/logo.png">-->
    <router-view />
    <!-- <v-footer v-if="this.$route.meta.isShowComm"></v-footer> -->
  </div>
</template>
<style>
html,
body,
#app {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden;
}

.modal-dialog {
  background: #fff;
}

.modal-body {
  max-height: 680px;
  overflow-y: scroll;
  min-height: 300px;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.main-sidebar::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

th,
td {
  vertical-align: middle !important;
  text-align: center !important;
}

.content-wrapper {
  background: #fff !important;
}

.content {
  /* margin: 10px; */
  background: #fff;
}

/* checkbox style */
.selected_remind_input input[type="checkbox"] {
  -webkit-appearance: none;
}

.selected_remind_input input[type="checkbox"]:checked + label,
.selected_remind_input input[type="checkbox"]:not(:checked) + label {
  background-color: #e0e0e0;
  border-radius: 24px;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  position: relative;
  text-indent: -9999px;
  width: 40px;
}

.selected_remind_input input[type="checkbox"]:checked + label:after,
.selected_remind_input input[type="checkbox"]:not(:checked) + label:after {
  background-color: #fff;
  border-radius: 20px;
  content: " ";
  height: 15px;
  left: 2px;
  position: absolute;
  top: 2px;
  width: 15px;
}

.selected_remind_input input[type="checkbox"]:checked + label {
  background-color: #4fc14f;
}

.selected_remind_input input[type="checkbox"]:checked + label:after {
  left: 22px;
}

.selected_remind_input input[type="checkbox"]:checked + label,
.selected_remind_input input[type="checkbox"]:not(:checked) + label {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.selected_remind_input input[type="checkbox"]:checked + label:after,
.selected_remind_input input[type="checkbox"]:not(:checked) + label:after {
  -webkit-transition: left 0.3s;
  transition: left 0.3s;
}

/* PC端css */
@media screen and (min-width: 960px) {
  .modal-dialog {
    width: 86% !important;
    z-index: 10;
    margin-top: 5% !important;
  }
}

@media screen and (max-width: 960px) {
  /* 手机端CSS代码 */
}
</style>
<script>
import Header from "@/components/header/header";
import Footer from "@/components/footer/footer";

export default {
  name: "App",
  components: {
    "v-header": Header,
    "v-footer": Footer,
  },
  mounted: function () {
    var access_token = localStorage.getItem("access_token");
    if (!access_token) {
      console.log("___App.vue 没有找到localStorage中的access_token");
      window.location.href = this.global.loginurl;
    }
    var company = localStorage.getItem("companyInfo");
    if (!company) {
      this.$router.push({
        name: "chooseCompany",
      });
    }

    // $(".file-pretty").prettyFile();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue